import { Store } from "pullstate";

const initialState = {
    initiative: null,
    dismissOptions: [],
    collaborators: [],
    followUps: [],
    shortlistCount: 0,
    activityCount: 0,
    actionItemsCount: 0,
    selectedOpportunity: null,
    isLoading: true,
    error: null,
};

export const InitiativeDetailsStore = new Store(initialState);

export const setInitiativeLoaded = ({ initiative, dismissOptions, collaborators }) => {
    InitiativeDetailsStore.update((s) => {
        s.initiative = initiative;
        s.dismissOptions = dismissOptions;
        s.collaborators = collaborators;
        s.isLoading = false;
        return s;
    });
};

export const setInitiativeError = (error) => {
    InitiativeDetailsStore.update((s) => {
        s.error = error;
        s.isLoading = false;
        return s;
    });
};

export const updateInitiativeInStore = (updates) => {
    InitiativeDetailsStore.update((s) => {
        s.initiative = { ...s.initiative, ...updates };
        return s;
    });
};

export const adjustShortlistCount = (delta) => {
    InitiativeDetailsStore.update((s) => {
        s.shortlistCount = s.shortlistCount + delta;
        return s;
    });
};

export const setShortlistCount = (count) => {
    InitiativeDetailsStore.update((s) => {
        s.shortlistCount = count;
        return s;
    });
};

export const setActivityCount = (count) => {
    InitiativeDetailsStore.update((s) => {
        s.activityCount = count;
        return s;
    });
};

export const setActionItemsCount = (count) => {
    InitiativeDetailsStore.update((s) => {
        s.actionItemsCount = count;
        return s;
    });
};

export const setSelectedOpportunity = (opportunity) => {
    InitiativeDetailsStore.update((s) => {
        s.selectedOpportunity = opportunity;
        return s;
    });
};

export const setFollowUps = (followUps) => {
    InitiativeDetailsStore.update((s) => {
        s.followUps = followUps;
        return s;
    });
};

export const resetInitiativeDetails = () => {
    InitiativeDetailsStore.update(() => ({ ...initialState }));
};

export const setCollaborators = (collaborators) => {
    InitiativeDetailsStore.update((s) => {
        s.collaborators = collaborators;
        return s;
    });
};

export const addCollaboratorToStore = (collaborator) => {
    InitiativeDetailsStore.update((s) => {
        if (!s.collaborators.some((c) => c.userId === collaborator.userId)) {
            s.collaborators = [...s.collaborators, collaborator];
        }
        return s;
    });
};

export const removeCollaboratorFromStore = (userId) => {
    InitiativeDetailsStore.update((s) => {
        s.collaborators = s.collaborators.filter((c) => c.userId !== userId);
        return s;
    });
};
